interface Option {
    [key: string]: any;
}

export const reduceById = (option: Option): number | string => option.id;

export const reduceByValue = (option: Option): number | string => option.value;

export const reduceByLabel = (option: Option): number | string => option.label;

export const reduceByKey = (option: Option, key: string): number | string => option[key];
